import React from "react";
import { observer, inject } from "mobx-react";
import styled from "styled-components";

import { Menu, Revert } from "grommet-icons";
import Button from "app/components/Button";

const ShowTOC = styled(Menu)`
  width: 48px;
  height: 48px;
  @media (max-width: 600px) {
    width: 24px;
    height: 24px;
  }
`;
const ReturnButton = styled(Revert)`
  width: 48px;
  height: 48px;
  @media (max-width: 600px) {
    width: 24px;
    height: 24px;
  }
`;

function ContentsButton({ AppState }) {
  const { isTOCMenuOpen: isOpen } = AppState;
  return (
    <Button
      title="Table of Contents"
      direction="row"
      pad="small"
      justify="center"
      align="center"
      fill="vertical"
      onClick={() => AppState.toggleTOCMenu()}
    >
      {!isOpen && <ShowTOC color="accent-1" />}
      {isOpen && <ReturnButton size="large" color="accent-1" />}
    </Button>
  );
}

export default inject("AppState")(observer(ContentsButton));



// WEBPACK FOOTER //
// ./src/app/components/MainMenu/ContentsButton.js